import ActivityCalendar, { Skeleton } from "./ActivityCalendar";

export { Skeleton };
export default ActivityCalendar;
